import Service from "../Service";

const resource = "ExitSeals/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    excel(obj , requestID) {
        const filter = obj.filter || {};
        return Service.post(resource + "excel", filter, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID: requestID },
        });
    },
    // excel(obj) {
    //     return Service.post(resource + "excel", {}, {
    //         responseType: "blob",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         params: {
    //             SlsDateBegin: obj.filter.SlsDateBegin,
    //             SlsDateEnd: obj.filter.SlsDateEnd
    //         },
    //     });
    // },
};